module.exports = __webpack_public_path__ + "img/mail-task.26ac1054.svg";